import { BaseDate } from '@/app/shared/utils/Date'

/* eslint-disable camelcase */

export default class TaskFormResponse {
  constructor ({ task_id, retail_name_store_name, response, content, created_at, created_by }) {
    this.taskId = task_id
    this.storeName = retail_name_store_name
    this.response = response
    this.content = content
    this.createdAt = new BaseDate(created_at).toActivationDetailFormat
    this.createdBy = created_by.full_name
  }
}



// WEBPACK FOOTER //
// ./src/app/activations/models/TaskFormResponse.js